import gql from 'graphql-tag';

export const confirmGoogleCalendarConsentContext = gql`
  mutation confirmGoogleCalendarConsentContext(
    $session: String!
    $optionId: String!
  ) {
    confirmGoogleCalendarConsentContext(
      session: $session
      optionId: $optionId
    ) {
      status
      syncSession
    }
  }
`;

export const requestGoogleCalendarDraftTesterOptOut = gql`
  mutation requestGoogleCalendarDraftTesterOptOut(
    $email: String!
    $message: String
  ) {
    requestGoogleCalendarDraftTesterOptOut(email: $email, message: $message)
  }
`;
